<template>
  <section class="padding">
      <div class="row">
          <div class="container1">
<img class="paddingtop" src="../../assets/newsletter.png" alt="">
          </div>

          <div class="container2">
<h2>Newsletter</h2>
<h4>Sign up to receive tips, tricks and techniques about kids' yoga.</h4>
<button>Sign me in</button>
          </div>

          <div class="container3">
<img class="paddingtop" src="../../assets/newsletter1.png" alt="">
          </div>
          
      </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.padding{
padding-top: 70px;
}
h2{
    color: white;
    
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
}
h4{
    color: white;
    font-weight: 500;
    line-height: 150%;
}
button:hover{
    background-color: #ca6500;
}
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 70px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
.row{
    display: flex;
    justify-content: space-around;
    width: 90%;
    margin: auto;
    border-radius: 20px;
    background-color: #60993E;
    min-height: 307px;
    flex-wrap: wrap;
}
.container2{
        display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    text-align: center;
}
.paddingtop{
    padding-top: 77px;
}
@media (max-width : 796px ){
    .row{
 min-height: 1038px;  
    }
   
}
</style>